import React, { useEffect, useState } from "react";
import backgroundImg from "../../Assets/Images/background.png";
import HelpModal from "./helpModal";

const actions = [
  { label: "Create Custom Graph", href: "/create" },
  { label: "View Interactive Map", href: "/map" },
  { label: "Access Data", href: "/access" },
];

const LOCALSTORAGE_KEY = "cdem_help_seen";

const MainPageSection = () => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  useEffect(() => {
    // Show the help if not seen before
    const hasSeen = localStorage.getItem(LOCALSTORAGE_KEY) === "true";
    if (!hasSeen) setIsHelpOpen(true);
  }, []);

  const handleCloseHelp = () => {
    localStorage.setItem(LOCALSTORAGE_KEY, "true");
    setIsHelpOpen(false);
  };

  const handleOpenHelp = () => setIsHelpOpen(true);

  return (
    <section className="relative flex min-h-screen items-center justify-center bg-cover bg-center">
      {/* ─── blurred background image ─── */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* ─── dark gradient overlay ─── */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70" />

      {/* ─── foreground content ─── */}
      <div className="relative z-10 text-center px-4">
        <h1 className="text-white text-5xl md:text-7xl font-bold tracking-tight">
          Data&nbsp;Playground
        </h1>

        {/* action buttons */}
        <div className="mt-10 flex flex-col sm:flex-row flex-wrap justify-center gap-4">
          {actions.map(({ label, href }) => (
            <a
              key={href}
              href={href}
              className="px-6 py-3 rounded-full border border-white/70 text-white text-base md:text-lg font-medium backdrop-blur transition hover:bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
            >
              {label}
            </a>
          ))}
        </div>
      </div>

      {/* Help modal + floating question mark */}
      <HelpModal isOpen={isHelpOpen} onClose={handleCloseHelp} onOpen={handleOpenHelp} />
    </section>
  );
};

export default MainPageSection;
